// 后面新的对接接口 先放这里吧


import request from '@/utlis/request'

/**
 * 根据委托的id查询拖车详细信息
 * @param {*} data
 * @returns
 */
export function findTrailerPrice(params) {
  return request({
    url: '/admin/trailerPrice/findTrailerInfoByMaintainId',
    method: 'GET',
    params
  })
}


/**
 * 添加拖车计算
 * @param {*} data
 * @returns
 */
export function trailerPrice(data) {
  return request({
    url: '/admin/trailerPrice/trailerPrice',
    method: 'POST',
    data
  })
}

/**
 * 拖车费用计算保存
 */
export function saveTrailerPrice(data) {
  return request({
    url: '/admin/trailerPrice/saveTrailerPrice',
    method: 'POST',
    data
  })
}


/**
 * 申请整备费用
 */
export function servicingCost(data) {
  return request({
    url: '/admin/servicingCost/servicingCost',
    method: 'POST',
    data
  })
}
/**
 * 保存整备信息
 */
export function saveServicing(data) {
  return request({
    url: '/admin/servicingCost/saveServicing',
    method: 'POST',
    data
  })
}


/**
 * 申请奖励
 */
export function addApplication(data) {
  return request({
    url: '/admin/application/addApplication',
    method: 'POST',
    data
  })
}


/**
 * 添加首款支付
 */
export function addFirstInstallment(data) {
  return request({
    url: '/admin/task/firstInstallment/addFirstInstallment',
    method: 'POST',
    data
  })
}

/**
 * 修改首款支付
 */
export function saveFirstInstallment(data) {
  return request({
    url: '/admin/task/firstInstallment/saveFirstInstallment',
    method: 'POST',
    data
  })
}
/**
 * 获取首款支付 -firstId
 *
 */
export function findFirstInstallment(params) {
  return request({
    url: '/admin/task/firstInstallment/findFirstInstallment',
    method: 'GET',
    params
  })
}
/**
 * 保存额外费用
 */
export function updateAdditionalCost(data) {
  return request({
    url: '/admin/additionalCost/updateAdditionalCost',
    method: 'POST',
    data
  })
}
/**
 * 查询额外费用
 */
export function selectAdditionalCost(params) {
  return request({
    url: '/admin/additionalCost/selectAdditionalCost',
    method: 'GET',
    params
  })
}

/**
 * 更新派车公司给App
 */
export function towCrew(params) {
  return request({
    url: '/admin/trailerInfo/towCrew',
    method: 'POST',
    params
  })
}

/**
 * 修改车辆照片
 */
export function updateCarPhoto(data) {
  return request({
    url: '/admin/car/updateCarPhoto',
    method: 'POST',
    data
  })
}

/**
 * 修改车主照片
 */
export function updateOwnerPhoto(data) {
  return request({
    url: '/admin/ownerphotos/updateOwnerPhoto',
    method: 'POST',
    data
  })
}
/**
 * 查询车主照片
 */
export function selectOwnerPhoto(params) {
  return request({
    url: '/admin/ownerphotos/selectOwnerPhoto',
    method: 'GET',
    params
  })
}

/**
 * 修改保全照片
 */
export function updateMaintainPhoto(data) {
  return request({
    url: '/admin/maintainphotos/updateMaintainPhoto',
    method: 'POST',
    data
  })
}
/**
 * 查询保全照片
 */
export function selectMaintainPhoto(params) {
  return request({
    url: '/admin/maintainphotos/selectMaintainPhoto',
    method: 'GET',
    params
  })
}


/**
 * 查询车辆照片
 */
export function selectCarPhoto(params) {
  return request({
    url: '/admin/car/selectCarPhoto',
    method: 'GET',
    params
  })
}

/**
 * 获取车的信息
 */
export function findCarInformation(params) {
  return request({
    url: '/admin/car/findCarInformation',
    method: 'GET',
    params
  })
}

/**
 * 修改费用照片
 */
export function updateMoneyPhoto(data) {
  return request({
    url: '/admin/moneyphotos/updateMoneyPhoto',
    method: 'POST',
    data
  })
}
/**
 * 查询费用照片
 */
export function selectMoneyPhoto(params) {
  return request({
    url: '/admin/moneyphotos/selectMoneyPhoto',
    method: 'GET',
    params
  })
}

/**
 * 修改菜单排序
 */

export function menuUpdateSort(data) {
  return request({
    url: '/admin/sysmenu/updateSort',
    method: 'POST',
    data
  })
}

/**
 * 批量修改菜单排序
 */

export function updateBatchSort(data) {
  return request({
    url: '/admin/sysmenu/updateBatchSort',
    method: 'POST',
    data
  })
}



/**
 * 图片上传
 */
export function uploadFile(data) {
  return request({
    url: '/file/uploadFile',
    method: 'POST',
    data
  })
}
